import React from 'react';
import linkTo from 'linkTo';
import Link from 'common/Link/BaseLink';
import Box from 'libs/core-components/Box/Box';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';
import { SolidAnchorButton } from 'libs/core-components/SolidButton/SolidAnchorButton/SolidAnchorButton';
import { Layout } from './common/Layout';

function TermsUpdate({ redirectUrl }: { redirectUrl: string }) {
    return (
        <Layout title={__('Update to our Terms of Use')} heading={__('Update to our Terms of Use')}>
            <Box>
                <p>
                    {__(
                        'We would like to inform you of a recent change we’ve made to our Terms of Use.'
                    )}
                </p>
                <p>
                    {__(
                        'You can no longer include personal contact information in your 99designs Profile such as:'
                    )}
                </p>
                <ul>
                    <li>{__('email')}</li>
                    <li>{__('video and messaging chat (e.g. Skype)')}</li>
                    <li>{__('phone')}</li>
                </ul>
                <p>{__('However, you can include:')}</p>
                <ul>
                    <li>{__('your personal website')}</li>
                    <li>{__('offsite portfolios showcasing your work')}</li>
                </ul>
                <p>
                    {__(
                        '99designs is continuing to build a platform that supports and protects designers from situations like phishing, client and payment disagreements, etc.'
                    )}
                </p>
                <p>
                    <FormattedReactMessage
                        message={__(
                            'Please take a moment to read the change under <Link>4.2 Non-Circumvention</Link>, and keep in mind that by continuing to use our services you are agreeing to our Terms. '
                        )}
                        replacements={{
                            Link: <Link href={linkTo.termsOfUse()} target="_blank" />,
                        }}
                    />
                </p>
                <SolidAnchorButton href={redirectUrl} variant="primary" width="fill">
                    {__('Continue')}
                </SolidAnchorButton>
            </Box>
        </Layout>
    );
}

export default TermsUpdate;
